<template>
  <div>
    <div class="d-flex mb-2">
      <div class="side-frame-success" style="margin-bottom: 0;"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          No：{{ formData.hxJdOrderNo }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Status：{{ formData.jdOrderStatus }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          Modify：{{ formData.modifyByName }} at {{ formData.modifyDate }}
        </span>
      </div>
    </div>
    <el-form ref="form" size="small" :model="formData" :rules="rules">
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item :label="$l('form_label_hxShipmentJdNo') || '计划单号'">
            <el-input v-model="formData.hxShipmentJdNo" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_orderProperties') || '订单属性'">
            <el-input v-model="formData.orderProperties" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_carNumberPlate') || '车牌号'">
            <el-input v-model="formData.carNumberPlate" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_vehicleModel') || '车型'">
            <el-input v-model="formData.vehicleModel" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdDc') || '配送中心'">
            <el-input v-model="formData.jdDc" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form__label_jdWh') || '京东仓库'">
            <el-input v-model="formData.jdWh" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            :label="$l('form_label_whAddress') || '京东仓库详细地址'"
          >
            <el-input v-model="formData.whAddress" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$l('form_label_whContact') || '收货负责人'">
            <el-input v-model="formData.whContact" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_whContactPhone') || '收货电话'">
            <el-input v-model="formData.whContactPhone" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_jdPurchaser') || '采购员'">
            <el-input v-model="formData.jdPurchaser" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_jdCreator') || '建单人'">
            <el-input v-model="formData.jdCreator" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdPurchaserTime') || '订购时间'">
            <el-input v-model="formData.jdPurchaserTime" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdInStockTime') || '入库时间'">
            <el-input v-model="formData.jdInStockTime" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_jdAppointmentTime') || '预约时间'"
          >
            <el-input v-model="formData.jdAppointmentTime" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_jdCloseTime') || '预计关单时间'">
            <el-input v-model="formData.jdCloseTime" readonly />
          </el-form-item>
        </el-col>

        <el-col :span="3">
          <el-form-item :label="$l('form_label_totCtnQty') || '总箱数'">
            <el-input v-model="totCtnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_totFclCtnQty') || '整箱箱数'">
            <el-input v-model="totFclCtnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_totTailCtnQty') || '尾箱箱数'">
            <el-input v-model="totTailCtnQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_totPurchaseQty') || '产品总数'">
            <el-input v-model="totPurchaseQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totPurchaseAmount') || '总采购金额'"
          >
            <el-input v-model="totPurchaseAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totCtnCbm') || '总纸箱体积(立方米)'"
          >
            <el-input v-model="totCtnCbm" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totCtnGrossWeight') || '总箱毛重(kg)'"
          >
            <el-input v-model="totCtnGrossWeight" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totCtnNetWeight') || '总箱净重(kg)'"
          >
            <el-input v-model="totCtnNetWeight" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totActualQty') || '实收产品总数量'"
          >
            <el-input v-model="totActualQty" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item
            :label="$l('form_label_totActualAmount') || '实收总金额'"
          >
            <el-input v-model="totActualAmount" readonly />
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_currencyUnit') || '货币单位'">
            <el-input v-model="formData.currencyUnit" readonly />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
// import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { format } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    hxJdOrderCode: { type: String, default: '' },
    jdOrderStatus: { type: String, default: '' },
  },
  data() {
    return {
      formData: {},
      rules: {
        shippingDate: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
        isUrgent: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    totCtnQty() {
      return format(this.formData.totCtnQty) || 0
    },
    totFclCtnQty() {
      return format(this.formData.totFclCtnQty) || 0
    },
    totTailCtnQty() {
      return format(this.formData.totTailCtnQty) || 0
    },
    totPurchaseQty() {
      return format(this.formData.totPurchaseQty) || 0
    },
    totPurchaseAmount() {
      return format(this.formData.totPurchaseAmount) || 0
    },
    totCtnCbm() {
      return format(this.formData.totCtnCbm) || 0
    },
    totCtnGrossWeight() {
      return format(this.formData.totCtnGrossWeight) || 0
    },
    totCtnNetWeight() {
      return format(this.formData.totCtnNetWeight) || 0
    },
    totActualQty() {
      return format(this.formData.totActualQty) || 0
    },
    totActualAmount() {
      return format(this.formData.totActualAmount) || 0
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.hxJdOrderCode) return
      const params = { hxJdOrderCode: this.hxJdOrderCode }
      const res = await this.$api
        .ecomHxShipmentJdOrderDetailApi(params)
        .catch(() => null)
      this.formData = res?.body || {}
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
::v-deep {
  .el-tag--vehicle {
    background-color: #f9f0ff !important;
    border-color: #d3adf7 !important;
    color: #732ed1 !important;
  }
}
</style>
